import { FieldWrapper, InputText } from '@dixa/lib-shared-habla';
import { ComponentProps, ReactNode } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import { getFieldMeta } from '../../utils';

export type FieldInputTextProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label?: ReactNode;
  placeholder?: string;
  required?: boolean;
  description?: string;
  disabled?: boolean;
  prefix?: ComponentProps<typeof InputText>['prefix'];
};
/** React Hook Form input component wrapped within a Habla FieldWrapper */
export function FieldInputText<T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  required,
  description,
  disabled,
  prefix,
}: FieldInputTextProps<T>): JSX.Element {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        const { ref, value = '', ...fieldWithoutRef } = field;
        const meta = getFieldMeta(fieldState);
        return (
          <FieldWrapper
            label={label}
            required={required}
            meta={meta}
            description={description}
            noLabel={!label}
          >
            <InputText
              {...fieldWithoutRef}
              value={value}
              placeholder={placeholder}
              disabled={disabled}
              prefix={prefix}
            />
          </FieldWrapper>
        );
      }}
    />
  );
}
